import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'

import { Loading } from '@/components/Loading'
import { Step4Wrapper } from '@/containers/steps/vehicle/extra/Step4/Step4Wrapper'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { MeetingRecordProvider } from '@/context/MeetingRecordProvider'
import OffersAddonProvider from '@/context/OffersAddonProvider'
import { SelectedOffersAddonProvider } from '@/context/SelectedOffersAddonProvider'
import { SidebarProvider } from '@/context/SidebarContext'
import { StepsProvider } from '@/context/StepsContext'
import { WizzardHeaderProvider } from '@/context/WizzardHeaderContext'
import { WithAuth } from '@/hoc/WithAuth'

const Step4PageComponent = () => {
  const navigate = useNavigate()
  const {
    insuranceParamsId: paramsId,
    isLoadingData,
    insuranceParams,
    isContracted,
  } = useInsuranceParams()

  const [showData, setShowData] = useState(!isLoadingData && insuranceParams)
  useEffect(() => {
    setShowData(!isLoadingData && insuranceParams)
  }, [!!insuranceParams, isLoadingData])

  useEffect(() => {
    if (isContracted) navigate(`/extra/steps/complete/${paramsId}`)
  }, [isContracted])

  return (
    <StepsProvider currentStepId={4}>
      <SidebarProvider>
        <WizzardHeaderProvider>
          {isLoadingData && <Loading large={true} />}

          {showData && (
            <MeetingRecordProvider addon insuranceParamsId={paramsId!}>
              <OffersAddonProvider>
                <SelectedOffersAddonProvider>
                  <Step4Wrapper />
                </SelectedOffersAddonProvider>
              </OffersAddonProvider>
            </MeetingRecordProvider>
          )}
        </WizzardHeaderProvider>
      </SidebarProvider>
    </StepsProvider>
  )
}

export const Step4Page = WithAuth(Step4PageComponent)
